import React from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import styles from './interviewsArtwork.css';

const AboutArtwork = () => {
  const isTouch = isMobile || isTablet;

  return (
    <div
      className={`${styles.wrapper} ${isTouch ? styles.touch : ''}`}>
      <div className={styles.gradient} />
    </div>
  );
};

export default AboutArtwork;
